import type { FC, ReactNode } from 'react';
import styles from './styles.module.scss';

type PageContainerProps = {
	children: ReactNode;
	/**
	 * Opt out of the reading-width cap and span the viewport. For pages that put
	 * something at the far edge, or a table worth the room — whatever inside
	 * still needs a comfortable measure then caps itself.
	 */
	wide?: boolean;
};

const PageContainer: FC<PageContainerProps> = ({ children, wide = false }) => {
	const className = [styles.container, wide && styles.wide].filter(Boolean).join(' ');

	return <main className={className}>{children}</main>;
};

export default PageContainer;
